import { render, staticRenderFns } from "./SettingGroup.vue?vue&type=template&id=9d3251c2&scoped=true&lang=html&"
import script from "./SettingGroup.vue?vue&type=script&lang=js&"
export * from "./SettingGroup.vue?vue&type=script&lang=js&"
import style0 from "./SettingGroup.vue?vue&type=style&index=0&id=9d3251c2&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d3251c2",
  null
  
)

export default component.exports